"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M21.498 0a2.516 2.516 0 0 1 2.496 2.336L24 2.5v8c0 .607-.214 1.177-.604 1.624l-.137.145-10.994 10.995c-.41.42-.97.68-1.558.728l-.224.008a2.473 2.473 0 0 1-1.61-.605l-.143-.135-7.993-7.996A2.447 2.447 0 0 1 0 13.499c0-.61.214-1.179.606-1.626l.137-.144.148-.137L11.605.876l.047-.055.087-.088a2.453 2.453 0 0 1 1.55-.725L13.487 0h8.012Zm-.002 1.003h-8.007c-.39 0-.768.16-1.039.438l-.07.07-.027.032-10.92 10.914a1.442 1.442 0 0 0-.429 1.042c0 .352.12.68.338.942l.1.108 8.002 8.005c.242.248.563.401.9.436l.145.007c.32-.007.683-.123.952-.34l.11-.099 11.003-11.003c.251-.245.402-.561.436-.906l.007-.149V2.503A1.511 1.511 0 0 0 21.64 1.01l-.144-.007Zm-4.232 2.78a2.088 2.088 0 1 1 2.952 2.953 2.088 2.088 0 0 1-2.952-2.953Zm1.476.392a1.085 1.085 0 1 0 .003 2.169 1.085 1.085 0 0 0-.003-2.17Z",
    clipRule: "evenodd"
  })]
});